<div class="pv-input">
	@if (label) {
		<ic-label [class.error]="error" [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
			{{ label }}
		</ic-label>
	}
	@for (lang of languages; track lang; let odd = $odd; let even = $even) {
		<div
			class="border pv-input__field"
			[class.error]="hasError(lang)"
			[class.even]="even"
			[class.odd]="odd"
			[class.stacked]="stacked"
		>
			<i aria-hidden="true" class="indicator" [class.disabled]="disabled"> {{ lang }} </i>
			<input
				type="text"
				[attr.data-test]="lang + '-name-input'"
				[disabled]="disabled"
				[placeholder]="placeholder"
				[value]="value[lang] || ''"
				(blur)="onTouched(lang)"
				(input)="individualOnChange(lang, $any($event).target.value)"
			/>
		</div>
	}
	<div [class.error]="error"><ng-content select=".errors" /></div>
</div>
